import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { Centre as CentreType } from '../../../../../types/centre'
import { CentreSelector as SharedCentreSelector } from '../../../../components/centre-selector'
import headerStyles from '../index.module.scss'
import navStyle from './index.module.scss'

const style = { ...headerStyles, ...navStyle }

export const CentreSelector = withRouter(
  ({
    centres,
    centre: currentCentre,
    onClose,
  }: RouteComponentProps & {
    centres: CentreType[]
    centre?: CentreType
    onClose: () => void
  }) => (
    <SharedCentreSelector
      centres={centres}
      centre={currentCentre}
      navStyle={style}
      onClose={onClose}
    />
  )
)
